if (!customElements.get("pagination-trigger")) {
  customElements.define(
    "pagination-trigger",
    class PaginationTrigger extends HTMLElement {
      constructor() {
        super();
        this.productGrid = this.parentElement.querySelector(
          "ul[data-product-grid]"
        );
        this.loadMoreButton = this.querySelector(
          '[data-pagination-trigger="load-more"]'
        );
        this.nextPageUrl =
          this.loadMoreButton.getAttribute("data-next-page-url");
        this.loadingSpinner = this.querySelector(
          '[data-loading-icon="loading__spinner"]'
        );

        this.loadMoreButton.addEventListener("click", () =>
          this.buttonClicked()
        );
      }
      async buttonClicked() {
        this.loadMoreButton.classList.add("hidden");
        this.loadingSpinner.classList.remove("hidden");

        try {
          // Fetch next page
          const response = await fetch(this.nextPageUrl);
          const html = await response.text();
          const parsedHTML = new DOMParser().parseFromString(html, "text/html");

          const newPageUrlElement = parsedHTML.querySelector(
            '[data-pagination-trigger="load-more"]'
          );
          const newPageUrl = newPageUrlElement
            ? newPageUrlElement.getAttribute("data-next-page-url")
            : null;

          // Append new products to the product grid
          const newProductUl = parsedHTML.querySelector(
            "ul[data-product-grid]"
          );
          const newProductLi = newProductUl.querySelectorAll("li");
          newProductLi.forEach((li) => {
            if (!li.hasAttribute("data-featured-card")) {
              this.productGrid.appendChild(li);
            }
          });

          if (newPageUrl) {
            this.nextPageUrl = newPageUrl;
            this.loadMoreButton.classList.remove("hidden");
          } else {
            console.warn("No next page URL found in the fetched content.");
            this.loadMoreButton.classList.add("hidden");
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          // Hide loading spinner and show pagination icon
          this.loadingSpinner.classList.add("hidden");
        }
      }
    }
  );
}
